import React, { useState } from "react";
import {
  Box,
  Button,
  Paper,
  TextField,
  Typography,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

const ResetPasswordPage = ({ serverUrl, showMessage }) => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const initialToken = searchParams.get("token") || "";
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = () => {
    if (!token || !password) {
      showMessage(t("resetPasswordMissingFields"));
      return;
    }
    if (password !== confirmPassword) {
      showMessage(t("resetPasswordMismatch"));
      return;
    }
    setSubmitting(true);
    axios
      .post(`${serverUrl}/reset-password`, { token, password })
      .then((res) => {
        showMessage(res?.data?.message || t("resetPasswordSuccess"));
        setPassword("");
        setConfirmPassword("");
      })
      .catch((error) => {
        const message =
          error?.response?.data?.message || t("resetPasswordError");
        showMessage(message);
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="h5" gutterBottom>
        {t("resetPasswordTitle")}
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        {t("resetPasswordDescription")}
      </Typography>
      <Stack spacing={2} mt={2}>
        <TextField
          label={t("resetPasswordToken")}
          value={token}
          onChange={(e) => setToken(e.target.value)}
          fullWidth
        />
        <TextField
          label={t("newPassword")}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          fullWidth
        />
        <TextField
          label={t("confirmPassword")}
          type="password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          fullWidth
        />
        <Box>
          <Button
            variant="contained"
            onClick={handleSubmit}
            disabled={submitting}
          >
            {t("resetPasswordButton")}
          </Button>
        </Box>
      </Stack>
    </Paper>
  );
};

export default ResetPasswordPage;
